import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=17327f9d&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=17327f9d&prod&lang=scss"
import style1 from "./ProductDetails.vue?vue&type=style&index=1&id=17327f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17327f9d",
  null
  
)

export default component.exports